import axiosClient, { app_uri } from "../../utils/axiosFactory";
import { SubscriptionClient } from "../repsaApi";

const client = new SubscriptionClient(app_uri, axiosClient());

export default client;
